<div class="container">
  <div class="header-wrapper">
    <ul>
      <li class="logout" (click)="logout();">logout</li>
    </ul>
  </div>
</div>